import type { ModuleKey } from './biModuleRegistry';

/**
 * Pretty URL pored BIS catch-all SPA.
 * /uprava/zlato = m.1111, /uprava/pl = m.2.1 Uprava P&L.
 * Nginx se ne dira: Laravel vec servira app na svim putanjama.
 */
export const MODULE_PRETTY_PATH: Partial<Record<ModuleKey, string>> = {
    ado_1111: '/uprava/zlato',
    uprava_pl: '/uprava/pl',
    uprava_dash: '/uprava/dash',
    pnl_kocka: '/uprava/pl23',
    pnl_explorer: '/uprava/pl24',
    price_triggers: '/triggeri',
};

export function moduleFromPathname(pathname: string): ModuleKey | null {
    const p = pathname.replace(/\/+$/, '') || '/';
    for (const [key, path] of Object.entries(MODULE_PRETTY_PATH) as Array<[ModuleKey, string]>) {
        if (p === path) {
            return key;
        }
    }
    return null;
}

export function prettyPathFor(module: ModuleKey): string | null {
    return MODULE_PRETTY_PATH[module] ?? null;
}
